import { useLocation } from 'react-router-dom';
import { useEndAppUpdateHandoverOnNavigate } from '@hooks/use-app-update';

/**
 * Ends the extraction screen's deferral once the user has landed somewhere.
 *
 * Renders nothing. It exists only to be inside the router: AppUpdateModal, which
 * owns the prompt, is mounted outside it and so cannot read the location. The
 * extraction modal defers the prompt when a run finishes and unmounts on the way
 * to the draft, and this is what tells the guard the user got there.
 */
export default function AppUpdateHandoverWatcher() {
  useEndAppUpdateHandoverOnNavigate(useLocation().pathname);
  return null;
}
